import styles from '../pa_checklist.module.scss';

const getPriorityStatus = (statuses) => {
  if (statuses.includes('error')) return 'error';
  if (statuses.includes('warning')) return 'warning';
  return 'ok';
}

const Indicator = ({ status }) => {
  const baseStyle = {
    width: '18px',
    height: '18px',
    borderRadius: '4px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '2px solid #333',
    margin: '0 4px',
  };

  if (status === 'error') {
    return (
      <div style={{ ...baseStyle, backgroundColor: '#FF4C4C' }}>
        <svg
          viewBox="0 0 12 12"
          width="10"
          height="10"
          fill="none"
          stroke="#000000"
          strokeWidth="2"
        >
          <line x1="2" y1="2" x2="10" y2="10" />
          <line x1="10" y1="2" x2="2" y2="10" />
        </svg>
      </div>
    );
  }

  const bgColor = status === 'warning' ? '#FFD700' : '#4CAF50';

  return <div style={{ ...baseStyle, backgroundColor: bgColor }} />;
}

const getGradientForStatus = (status) => {
  switch (status) {
    case 'error':
      return 'radial-gradient(circle at center, rgba(255,76,76,0.8), transparent 90%)';
    case 'warning':
      return 'radial-gradient(circle at center, rgba(255,215,0,0.8), transparent 90%)';
    case 'ok':
      return 'radial-gradient(circle at center, rgba(76,175,80,0.8), transparent 90%)';
    default:
      return 'transparent';
  }
}

const ValidationStatusCell = ({ piloto, preco, composicao }) => {
  const priority = getPriorityStatus([piloto, preco, composicao]);
  const background = getGradientForStatus(priority);

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        background,
        padding: '4px 8px',
        borderRadius: '6px',
        gap: '6px'
      }}
    >
      <Indicator status={piloto} />
      <div className={styles.vertical_separator} style={{ width: '2px', backgroundColor: '#000' }} />
      <Indicator status={preco} />
      <div className={styles.vertical_separator} style={{ width: '2px', backgroundColor: '#000' }} />
      <Indicator status={composicao} />
    </div>
  );
}

export default ValidationStatusCell;
